import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  MenuController,
  ModalController,
  NavParams,
  PopoverController,
} from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-validasi-pp-detail',
  templateUrl: './validasi-pp-detail.component.html',
  styleUrls: ['./validasi-pp-detail.component.css'],
})
export class ValidasiPpDetailComponent implements OnInit {
  load: boolean = false;
  button: boolean = false;
  token: any;
  user: any;
  hasil: any;
  hsl: any;
  kw: any;

  selct: any = '';
  keterangan: any = '';
  absensiData: any;

  info: any = 'Daftar';

  checklists: any;

  foto: any = {};
  url: any = '';

  assign: any;

  img: File;
  idFoto: any = '';
  imageUrl?: string;
  sp: any = '';
  filename: any;
  fotoktp: any = '';
  photoKtp: any = '';

  desc: any = '';

  hasilX: any = {};

  fotoX: any = '';

  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public http: HttpClient,
    public loadingctrl: LoadingController,
    public alertctrl: AlertController,
    public util: UtilService,
    public activatedRoute: ActivatedRoute,
    public actionSheetController: ActionSheetController,
    public navParams: NavParams,
    public api: ApiService
  ) {
    this.kw = this.navParams.data.id;
    console.log('KW', this.kw);
  }

  ngOnInit() {
    this.getList();
  }


  navigate() {
    const lat = this.foto?.latitude;
    const lng = this.foto?.longitude;
    window.open(`https://www.google.com/maps?q=${lat},${lng}`, '_system');
  }

  handleSelection(selectedValue: string) {
    this.fotoktp = selectedValue;
    this.sp = this.fotoktp;
    console.log('sp', this.sp);
    this.imageUrl = this.sp;
  }

  getList() {
    this.load = true;
    this.api.get('backoffice/pp/validasi/list/' + this.kw).subscribe(
      (data) => {
        this.hasil = data;

        this.hsl = this.hasil.data;
        this.load = false;

        this.absensiData = this.hsl?.members;
        this.checklists = this.hsl?.checklists;

        this.assign = this.hsl?.assign;

        this.foto = this.hsl?.foto;
        const lat = this.foto?.latitude;
        const lng = this.foto?.longitude;

        this.fotoX = this.hsl?.foto;
        this.url = `https://www.google.com/maps?q=${lat},${lng}`;
      },
      (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      }
    );
  }

  update() {
    if(!this.load){
      if(this.desc == ''){
        this.util.showToast('Catatan Wajib Diisi','danger','bottom');
        return false;
      }
      this.load = true;
      let param = {
        notes: this.desc,
        foto: this.sp
      }
      console.log('param', param);
      
      this.api.put('backoffice/pp/validasi/'+this.kw, param)
        .subscribe((data) => {
          this.hasilX = data;
          this.util.showToast(this.hasilX.message,'success','bottom');
          this.api.dismissData('','confirm');
          this.load = false;
        }, (error) => {
          this.load = false;
          console.log('error', error);
          this.api.errorCond(error);
        });
      }
  }

  batal() {
    this.modalController.dismiss();
  }
}
